import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Divider from '@material-ui/core/Divider';

import { createHoliday, deleteHoliday } from '../../store/actions/holiday';
import ContentHeader from '../../components/ContentHeader/ContentHeader';
import Calendar from '../../components/Calendar/Calendar';
import CalendarDialog from '../../components/Calendar/CalendarDialog';

const styles = theme => ({
  legend: {
    display: 'flex',
    alignItems: 'center',
    padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
  },
  holiday: {
    display: 'inline-block',
    height: '22px',
    width: '22px',
    borderRadius: '50%',
    backgroundColor: '#30b299',
    marginRight: theme.spacing(1),
  },
  custom: {
    backgroundColor: '#3b94db',
  },
});

class Holidays extends React.Component {
  state = {
    openModal: false,
    currentAction: '',
    currentHoliday: {
      id: null,
      description: '',
      dtRef: '',
      date: '',
      location: {
        city: '',
        cod: '',
        state: '',
        uf: '',
      },
      isAnual: false,
      isNational: false,
      nacionalHoliday: false,
      dtRemoval: '',
      originalRemoval: new Date(),
      clearYear: false,
      clearEveryYear: false,
    },
  };

  onChange = (name, value) => {
    const newLocal = { ...this.state.currentHoliday };
    if (value === null) {
      newLocal.location = {};
    } else {
      newLocal.location = value;
    }
    this.setState({ currentHoliday: newLocal });
  }

  handleOpenModal = (type, eventDay, local) => {
    let newHoliday = null;
    if (type === 'Cadastrar') {
      newHoliday = {
        id: null,
        description: '',
        dtRef: eventDay.format('YYYY-MM-DD'),
        date: eventDay.format('LL'),
        location: {},
        isAnual: false,
        isNational: false,
        nationalHoliday: false,
      };
    } else {
      newHoliday = {
        id: eventDay.id,
        description: eventDay.title,
        dtRef: eventDay.start.format('YYYY-MM-DD'),
        date: eventDay.start.format('LL'),
        isAnual: eventDay.isAnual,
        location: eventDay.location,
        isNational: eventDay.isNational,
        nationalHoliday: eventDay.nationalHoliday,
      };
    }

    this.setState({ openModal: true, currentAction: type, currentHoliday: newHoliday });
  };

  handleChange = (event) => {
    const newTitle = { ...this.state.currentHoliday };
    if (event.target.name === 'annual') {
      newTitle.isAnual = event.target.checked;
    } else if (event.target.name === 'nacional') {
      newTitle.isNational = event.target.checked;
    } else if (event.target.name === 'year') {
      newTitle.clearYear = event.target.checked;
      newTitle.dtRemoval = newTitle.dtRef;
    } else if (event.target.name === 'everyYear') {
      newTitle.clearEveryYear = event.target.checked;
      newTitle.dtRemoval = `2000${newTitle.dtRef.slice(-6)}`;
    } else {
      newTitle.description = event.target.value;
    }
    this.setState({ currentHoliday: newTitle });
  };

  handleCloseModal = () => {
    this.setState({ openModal: false });
  };

  handleSubmitHoliday = (type) => {
    const { currentHoliday } = this.state;
    if (type === 'Cadastrar') {
      this.props.onCreateHoliday([
        {
          cityCod: currentHoliday.location.code,
          stateCod: currentHoliday.location.uf,
          description: currentHoliday.description.toUpperCase(),
          dtRef: currentHoliday.isAnual
            ? `2000${currentHoliday.dtRef.slice(-6)}`
            : currentHoliday.dtRef,
          originalRef: currentHoliday.dtRef,
        },
      ]);
    } else {
      this.props.onDeleteHoliday(currentHoliday.id, currentHoliday.dtRemoval, currentHoliday.nationalHoliday, currentHoliday.dtRef);
    }
    this.handleCloseModal();
  };

  render() {
    const { classes } = this.props;
    const { openModal, currentAction, currentHoliday } = this.state;
    return (
      <React.Fragment>
        <ContentHeader
          title="Configurar Feriados"
          subtitle="Selecione uma data para cadastrar feriados personalizados"
        />

        <Paper elevation={2}>
          <Calendar handleOpenModal={this.handleOpenModal} location={this.state.currentHoliday.location} />
          <Divider />
          <div className={classes.legend}>
            <span className={classes.holiday} />
            <Typography color="textSecondary">Feriados Nacionais</Typography>
          </div>
          <div className={classes.legend}>
            <span className={classNames(classes.holiday, classes.custom)} />
            <Typography color="textSecondary">Feriados Personalizados</Typography>
          </div>
        </Paper>

        <CalendarDialog
          open={openModal}
          onClose={this.handleCloseModal}
          modalType={currentAction}
          holiday={currentHoliday}
          handleChange={this.handleChange}
          onChange={this.onChange}
          onSubmit={this.handleSubmitHoliday}
        />
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  onCreateHoliday: holiday => dispatch(createHoliday(holiday)),
  onDeleteHoliday: (id, dtRemoval, isNational, originalRemoval) => dispatch(deleteHoliday(id, dtRemoval, isNational, originalRemoval)),
});

Holidays.propTypes = {
  classes: PropTypes.object.isRequired,
  onCreateHoliday: PropTypes.func.isRequired,
  onDeleteHoliday: PropTypes.func.isRequired,
};

export default connect(null, mapDispatchToProps)(withStyles(styles)(Holidays));
